import { DropdownButton } from 'pages/Shipments/components/ContainerActions';
import { useSelectionContext, useSelectionCount } from 'common/contexts/SelectionContext';
import * as React from 'react';

interface Props {
  children: React.ReactNode;
}

export const Bulk: React.FC<Props> = (props) => {
  const { selection } = useSelectionContext();
  const count = useSelectionCount(selection);

  const [isOpen, setIsOpen] = React.useState(false);
  const disabled = count === 0;

  return (
    <DropdownButton
      label="Bulk actions"
      isOpen={isOpen}
      onRequestOpen={setIsOpen}
      placement="bottom-start"
      disabled={disabled}
      tooltip={disabled ? <h4>Select containers to allow bulk actions.</h4> : null}
    >
      <div className="flex flex-col space-y-2">{props.children}</div>
    </DropdownButton>
  );
};
Bulk.displayName = 'Shipments.Containers.ActionBar.Bulk';
